var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-app-container" },
    [
      _vm.load
        ? _c(
            "div",
            { staticClass: "oc-settings" },
            [
              _c("main-header"),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "form-horizontal oc-form",
                  attrs: { method: "post", enctype: "multipart/form-data" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "tabs",
                    {
                      attrs: {
                        url: "#/ordercall",
                        tabs: _vm.tabs,
                        "tab-acive": _vm.tabAcive
                      },
                      on: { select: _vm.setTab }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "contents" }, slot: "contents" },
                        [
                          _vm.tabAcive == 0
                            ? _c("main-component", {
                                attrs: { settings: _vm.settings }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tabAcive == 1
                            ? _c("form-component", {
                                attrs: { settings: _vm.settings }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tabAcive == 2
                            ? _c("smart-button-component", {
                                attrs: { settings: _vm.settings }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tabAcive == 3
                            ? _c("notification", {
                                attrs: { settings: _vm.settings }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tabAcive == 4
                            ? _c("analytics", {
                                attrs: { settings: _vm.settings }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.shopOrdercall.debug && _vm.tabAcive == 0
                            ? _c("extra", { attrs: { settings: _vm.settings } })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("save-bar", {
        attrs: { "is-save": _vm.saved },
        on: { save: _vm.saveSettings }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e759e7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e759e7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/Settings.vue
// module id = 152
// module chunks = 0